import {useEffect, useState} from 'react';
import {getPaidInvoices} from "../../api/Api";
import {Table} from 'antd';
import {Link} from "react-router";


export const PaidInvoice = ({onRefresh, refresh, onApiFail, props}) => {
    const [invoices, setInvoices] = useState([]);

    useEffect(() => {
        getPaidInvoices().then(result => {
            console.log(result);
            setInvoices(result.map(i => {
                return {...i,
                    key: i.id
                }
            }));
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [refresh, onApiFail]);

    const selectInvoice = (invoice) => () => {
        // setFocusInvoice(invoice);
    }

    const columns = [
        {
            title: 'Invoice Number',
            dataIndex: 'invoiceNumber',
            key: 'invoiceNumber',
            render: (val, record) => {
                // return <div onClick={selectInvoice(record)} style={{cursor: 'pointer'}}>{val}</div>
                return <Link to={`/invoice/${record.id}`}>{val}</Link>
            },
            sorter: (a, b) => a.invoiceNumber.toLowerCase().localeCompare(b.invoiceNumber.toLowerCase()),
        },
        {
            title: 'Buyer',
            dataIndex: 'firstname',
            render: (val, record, index) => {
                return `${val} ${record.lastname}`
            },
            sorter: (a, b) => {
                const aName = `${a.firstname} ${a.lastname}`;
                const bName = `${b.firstname} ${b.lastname}`;
                return aName.localeCompare(bName);
            }
        },
        {
            title: 'Created by',
            dataIndex: 'username',
            key: 'username',
            sorter: (a, b) => a.username.localeCompare(b.username)
        },
        {
            title: 'Date',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val) => {
                const terms = val.split("T");
                return terms[0]
            },
            sorter: (a, b) => (new Date(a.timestamp))- (new Date(b.timestamp)),
        },
        {
            title: 'Subtotal',
            dataIndex: 'subtotal',
            key: 'subtotal',
            render: (val) => {
                return `$ ${val}`;
            },
            sorter: (a, b) => a.subtotal - b.subtotal,
        },
        {
            title: 'Paid',
            dataIndex: 'amountPaid',
            key: 'amountPaid',
            render: (val, record, index) => {
                return <div onClick={selectInvoice(record)} style={{cursor: 'pointer'}}>$ {val}</div>
            },
            sorter: (a, b) => a.amountPaid - b.amountPaid,
        },
        {
            title: 'Balance',
            dataIndex: 'subtotal',
            key: 'balance',
            render: (val, record, index) => {
                const floatVal = record.subtotal - record.amountPaid;
                const fixedVal = floatVal.toFixed(2);
                return `$ ${fixedVal}`
            }
        }
    ];

    const tableView = <Table dataSource={invoices} columns={columns} />
    const content = tableView;
    return <>
        {content}
    </>
}